import IMG1 from "../../assets/images/features-img-1.png";
import IMG2 from "../../assets/images/features-img-2.png";
import IMG3 from "../../assets/images/features-img-3.png";
import IMG4 from "../../assets/images/features-img-4.png";
import IMG6 from "../../assets/images/features-img-6.png";

export const topcards = [
  {
    img: IMG1,
    title: "FIAT & Crypto On-Ramps",
    description:
      "Sentinel dVPN application come built in with FIAT On-ramps as well as crypto payment gateways that allow users to pay in any currency they are comfortable with.",
  },
  {
    img: IMG2,
    title: "Censorship Resistant Nodes",
    description:
      "Sentinel has 1000s of nodes hosted anonmously and independently by individual node hosts, many hosted on residential IPs. This makes identifying and blocking these nodes almost impossible.",
  },
];
export const bottomcards = [
  {
    img: IMG3,
    title: "Custom Subscription Plans",
    description:
      "Sentinel dVPN application offer users monthly subscription plans that can be customised by the application builder. The plans allow application builders to choose which nodes the users can acess, the amount of data the user can use as well as the amount user pays per month.",
  },
  {
    img: IMG4,
    title: "Multiple VPN Protocol",
    description:
      "Sentinel nodes offer users a choice between 2 of the best VPN routing protocols in order to provide optimal VPN connectivity for any type of usage or location.",
  },
];
export const extracards = [
  {
    img: IMG6,
    title: "Easy to Fork",
    description:
      "The Sentinel dVPN application is fully modular and can be effortlessly forked by whitelabels without any prior knowledge of VPNs in order to launch their own dVPN applications.",
  },
  {
    title: "Provable encryption and no-logging",
    description:
      "Sentinel is fully built on a secure open-source and audited architecture making it impossible to add backdoors or track users in any manner. Furthermore the back-end of sentinel based applications run on a permissionless blockchain. providing a fully trustless environment for users.",
  },
];
